import { PROD } from '../config/stage'

const addTrailingSlash = (url: string) => (url.endsWith('/') ? url : `${url}/`)

const environmentPrefix = import.meta.env.VITE_STAGE === PROD ? '' : `shared-`
const defaultApiBaseUrl = `https://api.${environmentPrefix}platform.eidu.com/`

const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim()

const resolvedBaseUrl =
  configuredApiBaseUrl && configuredApiBaseUrl.length > 0 ? configuredApiBaseUrl : defaultApiBaseUrl

const apiBaseUrl = addTrailingSlash(resolvedBaseUrl)

export default apiBaseUrl
